// One place for the production origin.
//
// Previously this string was repeated in scripts/prerender.js, public/index.html
// and the JSON-LD in every page. Canonical tags and sitemap entries that
// disagree are worse than either alone, so they read from here.
//
// In the browser, window.location.origin is always correct and is used as-is.
// This constant is the fallback for build-time contexts (prerender, sitemap)
// where there is no window.
export const SITE_ORIGIN = "https://example.com";

export function originOf() {
  if (typeof window !== "undefined" && window.location) return window.location.origin;
  return SITE_ORIGIN;
}

/**
 * The date content on this site is considered to have first existed,
 * used as datePublished for any page whose recipe or reference entry has
 * no explicit `publishAt` — i.e. everything that was live from the first
 * deploy.
 *
 * This is a real, honest date rather than a placeholder: those pages
 * genuinely were live from this point on, and structured-data guidelines
 * (Google's HowTo and TechArticle rich-result docs both support
 * datePublished/dateModified) expect SOME date rather than none. What
 * this deliberately does NOT do is fabricate a dateModified that moves —
 * there is no real change-tracking in this codebase, so dateModified is
 * set equal to datePublished everywhere rather than invented to look
 * fresher than the content actually is. A false "recently updated"
 * signal is worse than an honest static one; search engines that catch
 * it discount the signal sitewide, not just on the page it's wrong on.
 *
 * Set this to the actual date you first deploy the site, and leave it
 * fixed after that — it is a historical fact once set, not something to
 * bump on every redeploy.
 */
export const SITE_LAUNCH_DATE = "2026-09-01";
